module.exports = __webpack_public_path__ + "img/login-visual.49685313.svg";